import axios from 'axios';
import queryString from 'query-string';
import ConstCode, { PROFILE } from '@/common/constants/ConstCode';
import { debounce } from 'lodash';
import { useLayoutStore } from '@/store/modules/layout';
import { useAccountStore } from '@/store/modules/account';

export * from '@/common/utils/module/ToastServiceResultSupport';

const scrollIsLocked = (locked) => {
  document.getElementsByTagName('main')[0].style = `overflow:${locked ? 'hidden' : 'auto'}`;
};

const loading = () => {
  const layoutStore = useLayoutStore();
  layoutStore.isLoading = true;
  scrollIsLocked(true);
};
const loaded = debounce(() => {
  const layoutStore = useLayoutStore();
  layoutStore.isLoading = false;
  scrollIsLocked(false);
}, 500);

class ServiceExec {
  constructor() {
    let axiosInstance = axios.create({
      baseURL: PROFILE === 'prod' ? ConstCode.CODE_ENV_LIST.API_URL : undefined
    });
    axiosInstance.interceptors.request.use(this.handleRequest);
    axiosInstance.interceptors.response.use(this.handleSuccess, this.handleError);

    axiosInstance.defaults.paramsSerializer = function (params) {
      return queryString.stringify(params, {
        arrayFormat: 'repeat',
        allowDots: true
      });
    };
    this.ServiceExec = axiosInstance;
  }

  async handleRequest(request) {
    const accountStore = useAccountStore();
    if (!request.url.startsWith('/admin/inquiry/read')) {
      loading();
    }
    const accessToken = accountStore.accessToken;
    if (accessToken) {
      request.headers[ConstCode.LOGIN_TOKEN_NAME] = `${accessToken}`;
    }
    return request;
  }
  async handleSuccess(response) {
    loaded();
    return response;
  }
  async handleError({ response }) {
    loaded();
    if (401 === response?.status) {
      setTimeout(() => location.replace('/'), 300);
    } else return Promise.resolve(response);
  }

  status = {
    OK: 200,
    ERROR: 500,
    NOT_FOUND: 404,
    UNAUTHORIZED: 401
  };

  get(path, params = {}) {
    return this.ServiceExec.request({
      method: 'GET',
      url: path,
      responseType: 'json',
      params: params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          arrayFormat: 'indices',
          skipEmptyString: true,
          skipNulls: true,
          allowDots: true
        })
    });
  }

  put(path, payload) {
    return this.ServiceExec.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
      // params: payload,
      // paramsSerializer: (payload) =>
      //   qs.stringify(payload, { arrayFormat: 'repeat' })
    });
  }
  patch(path, payload) {
    return this.ServiceExec.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  post(path, payload) {
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  put(path, payload) {
    return this.ServiceExec.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  delete(path, payload) {
    payload = `${path}?${queryString.stringify(payload)}`;
    return this.ServiceExec.delete(payload);
  }

  postWithProgressBar(path, payload) {
    return this.ServiceExec.post(path, payload, {
      onUploadProgress: (progressEvent) => {
        const layoutStore = useLayoutStore();
        layoutStore.isProgressBar = true;

        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        layoutStore.progress = percentage;

        if (percentage >= 100) {
          const timeout = setTimeout(() => {
            clearTimeout(timeout);
            layoutStore.isProgressBar = false;
          }, 500);
        }
      },
      header: {
        'Response-Type': 'application/json'
      }
    });
  }

  getWithProgressBar(path, payload) {
    return this.ServiceExec.get(path, payload, {
      onUploadProgress: (progressEvent) => {
        const layoutStore = useLayoutStore();
        layoutStore.isProgressBar = true;

        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        layoutStore.progress = percentage;

        if (percentage >= 100) {
          const timeout = setTimeout(() => {
            clearTimeout(timeout);
            layoutStore.isProgressBar = false;
          }, 500);
        }
      },
      header: {
        'Response-Type': 'application/json'
      }
    });
  }

  queryPost(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  multiPost(path, payload) {
    return this.ServiceExec.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  xl(path, params) {
    return this.ServiceExec.request({
      method: 'GET',
      url: path,
      responseType: 'arraybuffer',
      headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8' },
      params: params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          arrayFormat: 'indices',
          skipEmptyString: true,
          skipNulls: true,
          allowDots: true
        })
    });
  }
}

let instance;
const initialize = () => {
  if (!instance) instance = new ServiceExec();

  return instance;
};
export default initialize();
